import type {
  DatalakeS3ExportParams,
  DataLakeS3Export,
  UpdateDataLakeS3ExportOptions,
  FetchCarrierSelectionSummaryParams,
  CarrierSelectionSummary,
} from './types';
import GatewayAxiosClient from '../GatewayAxiosClient';
import qs from 'qs';

export class DatalakeService {
  public async fetchDatalakeExportList(): Promise<DataLakeS3Export[]> {
    const res = await GatewayAxiosClient.get(`/ui-reporting-proxy/api/v1/data-exports`);
    return res.data;
  }

  public async exportEntityToS3(params: DatalakeS3ExportParams): Promise<DataLakeS3Export> {
    const res = await GatewayAxiosClient.post(`/ui-reporting-proxy/api/v1/data-exports`, params);
    return res.data;
  }

  public async deleteDatalakeExport(datalakeExportId: string): Promise<any> {
    const res = await GatewayAxiosClient.delete(`/ui-reporting-proxy/api/v1/data-exports/${datalakeExportId}`);
    return res.data;
  }

  public async updateDatalakeExport(params: UpdateDataLakeS3ExportOptions): Promise<any> {
    const { datalakeExportId, ...rest } = params;
    const res = await GatewayAxiosClient.put(`/ui-reporting-proxy/api/v1/data-exports/${datalakeExportId}`, rest);
    return res.data;
  }
  public async fetchCarrierSelectionSummaries({
    startDate,
    endDate,
    partnerId,
    tenantIds,
    originIds,
  }: FetchCarrierSelectionSummaryParams): Promise<CarrierSelectionSummary[]> {
    return (
      await GatewayAxiosClient.get(
        `/shipium-internal-proxy/data-platform/partner/${partnerId}/carrier-selection-summary`,
        {
          params: {
            startDate,
            endDate,
            ...(tenantIds ? { tenantIds } : {}),
            ...(originIds ? { originIds } : {}),
          },
          paramsSerializer: (p) => {
            return qs.stringify(p, { arrayFormat: 'repeat' });
          },
        },
      )
    ).data;
  }
}
